import { authPut, getAuthBaseURL } from "@api/auth/auth";

export const refreshIdentity = (): Promise<{ token: string }> =>
  authPut<{}, { token: string }>(`${getAuthBaseURL()}/refresh`, {});
